import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");

if (!container) {
    throw new Error("Root element not found");
}

const root = createRoot(container);

import { AuthProvider } from "./context/AuthContext";

root.render(
    <AuthProvider>
        <App />
    </AuthProvider>
);